
import * as React from 'react';
import { CSSProperties } from 'react';
import { isNullOrEmpty } from '../../utils/util';

interface WalletTypeIconProps {
    walletType: string | null;
}

const imgStyle: CSSProperties = {maxHeight: '20px', marginLeft: '10px'}

const WalletTypeIcon = ({ walletType }: WalletTypeIconProps) => {
    
    if (isNullOrEmpty(walletType)) return null;

    switch (walletType) {
        case 'apple_pay': return <img style={imgStyle} src='/images/apple-pay.256x164.png'></img>
        case 'google_pay': return <img style={imgStyle} src='/images/google-pay.256x97.png'></img>
        case 'samsung_pay': return <img style={imgStyle} src='/images/samsung-pay.256x256.png'></img>
        default: return <span>[{walletType}]</span>
    }
}

export default WalletTypeIcon;